import type { RuntypeBase } from 'runtypes/lib/runtype';

export type InstanceAuthenticationConfiguration = {
	name: string;
	token: string;
	url: string;
	user: null | string;
};

export const normalizeInstanceAuthenticationConfiguration = (
	configuration: InstanceAuthenticationConfiguration
): InstanceAuthenticationConfiguration => {
	return configuration;
};

export const normalizeInstanceAuthenticationConfigurations = (
	configurations: InstanceAuthenticationConfiguration[]
): InstanceAuthenticationConfiguration[] => configurations.map(normalizeInstanceAuthenticationConfiguration);

export type SessionIdForToken = {
	sessionId: string;
};

const isSessionIdForToken = (value: unknown): value is SessionIdForToken =>
	value !== null && typeof value === 'object' && typeof (value as Record<string, unknown>).sessionId === 'string';

export const createSessionIdForTokenRunType = (): RuntypeBase<unknown> =>
	({
		check(value: unknown): unknown {
			const payload = value !== null && typeof value === 'object' && 'data' in value ? value.data : value;

			if (!isSessionIdForToken(payload)) {
				throw new Error('Expected session id response.');
			}

			return value;
		},
	}) as RuntypeBase<unknown>;
